namespace $ {
	/** Union/difference of half-open monotonic intervals, clipped to the observed window. */
	export function $shm_hitalama_map_loading_profile_interval(
		include: readonly ( readonly [ number, number ] )[],
		exclude: readonly ( readonly [ number, number ] )[],
		from: number, until: number,
	) {
		const events: [ number, number, number ][] = []
		for( const [ ranges, slot ] of [ [ include, 1 ], [ exclude, 2 ] ] as const ) {
			for( const range of ranges ) {
				const a = Math.max( from, range[0] ), b = Math.min( until, range[1] )
				if( !( b > a ) ) continue
				events.push([ a, slot === 1 ? 1 : 0, slot === 2 ? 1 : 0 ], [ b, slot === 1 ? -1 : 0, slot === 2 ? -1 : 0 ])
			}
		}
		events.sort( ( a, b )=> a[0] - b[0] )
		let inside = 0, outside = 0, previous = from, total = 0
		for( const [ tick, add, subtract ] of events ) {
			if( inside > 0 && outside === 0 ) total += tick - previous
			inside += add; outside += subtract; previous = tick
		}
		return total
	}
}
